import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Banner from '../banner/Banner.jsx';
import PublishInstructions from './PublishInstructions.jsx';
import s from './PublishView.module.scss';

export default class PublishView extends Component {
    static propTypes = {
        animationOptions: PropTypes.object.isRequired,
        banner: PropTypes.object.isRequired,
        hasAssetsWritePermission: PropTypes.bool.isRequired,
        publishPending: PropTypes.bool.isRequired,
        publishVenue: PropTypes.func.isRequired,
        startDate: PropTypes.object.isRequired,
        status: PropTypes.string.isRequired,
        stopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
        publishFrozen: PropTypes.bool,
    };

    static defaultProps = {
        publishFrozen: false,
    };

    handlePublishClick = () => {
        const { publishVenue } = this.props;
        publishVenue();
    };

    render() {
        const { animationOptions, banner, status, publishPending, stopDate, hasAssetsWritePermission, publishFrozen } =
            this.props;
        return (
            <div className={classNames(s.publishView)}>
                <div className={s.innerWrapper}>
                    <div className={s.topWrapper}>
                        <div className={s.titleWrapper}>
                            <div className={s.title}>Publish</div>
                            {!publishFrozen && (
                                <div className={s.subtitle}>Below you can publish queued changes and also see when the last group of changes were successfully published.</div>
                            )}
                        </div>
                        {!publishFrozen && <Banner banner={banner} />}
                    </div>
                    <PublishInstructions
                        animationOptions={animationOptions}
                        handlePublishClick={this.handlePublishClick}
                        hasAssetsWritePermission={hasAssetsWritePermission}
                        isVisible={banner.isVisible}
                        publishPending={publishPending}
                        publishFrozen={publishFrozen}
                        status={status}
                        stopDate={stopDate}
                    />
                </div>
            </div>
        );
    }
}
